import { Box, styled } from '@mui/material';

const StyledAvailabilityContainer = styled(Box)(() => ({
  height: '100%',
  whiteSpace: 'normal !important'
}));

export default StyledAvailabilityContainer;
